<svg fill="none" height="58" viewBox="0 0 48 58" width="48" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <clipPath id="a">
    <rect height="58" rx="4" width="48"/>
  </clipPath>
  <g clip-path="url(#a)">
    <path d="m0 0h48v22h-48z" fill="currentColor"/>
  </g>
  <rect height="57" rx="3.5" stroke="currentColor" width="47" x=".5" y=".5"/>
</svg>
